var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-header-container"},[_c('span',{staticClass:"header-title family"},[_vm._v(_vm._s(_vm.title))]),_c('van-icon',{staticClass:"arrow-left",attrs:{"name":"arrow-left"},on:{"click":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }